module.exports = __webpack_public_path__ + "static/media/firefox-step.a07f7e48.png";